import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import { TransactionEditPage,  TRANSACTION_UPDATED_EVENT} from '../transaction-form/transaction-form-edit';
import {TransactionAddPage,  TRANSACTION_CREATED_EVENT,} from '../transaction-form/transaction-form-add';
import { Events } from 'ionic-angular';
import { ItemSliding } from 'ionic-angular';
import { LoadingController, Loading } from 'ionic-angular';


@Component({
    selector: 'page-transaction',
    templateUrl: 'transaction.html',
})
export class TransactionPage {
    user_id: String
    account_id: String
    transactions = []
    report = {"this_month":{}, "last_month":{}}
    current_item: ItemSliding;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public server: ServerProvider, public modalCtrl: ModalController,
                public events: Events, public loadingCtrl: LoadingController) {
        this.user_id = this.navParams.get("user_id");
        this.account_id = this.navParams.get("account_id")

        events.subscribe(TRANSACTION_CREATED_EVENT, (transaction) => {
            console.log('transaction is ', transaction);
            this.transactions.unshift(transaction);
        });

        events.subscribe(TRANSACTION_UPDATED_EVENT, (transaction)=>{
            console.log('Updated transaction is ', transaction)
            if(this.current_item != null){
                this.current_item.close()
            }
        })
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad TransactionPage');
        this.fetchTransactions()
    }

    fetchTransactions(){
        let loader = this.loadingCtrl.create({
            content: "Bitte warten",
            duration: 5000
        });
        loader.present()
        this.server.getTransactions(this.user_id, this.account_id).subscribe(
            data => {
                this.transactions = data.json()
                loader.dismiss()
            },
            error => {
                loader.dismiss()
            }
        )
    }

    fetchReport(){
        
    }

    edit_transaction(idx, transaction, slidingItem){
        this.current_item = slidingItem;

        let modal = this.modalCtrl.create(TransactionEditPage, {"user_id":this.user_id, "account_id":this.account_id, "transaction": transaction});
        modal.present();

    }

    delete_transaction(idx, transaction, slidingItem){

        console.log("Delete " + transaction.id)
        this.transactions.splice(idx, 1)

        this.server.deleteTransaction(this.user_id, this.account_id, transaction.id).subscribe(
            data=>{
                this.fetchTransactions()
            },
            error=>{
                console.error(error.text())
            }
        )
    }

    new_transaction(){
        let modal = this.modalCtrl.create(TransactionAddPage, {"user_id":this.user_id, "account_id":this.account_id});
        modal.present();
        /*
        $state.go('transactions_add', {"userId":$stateParams.userId, "accountId":$stateParams.accountId})
        */
    }
}



// WEBPACK FOOTER //
// ./src/pages/transaction/transaction.ts